import owd from 'owd/owd';

export default class Menu extends owd.Component {
	init() {
        this.close = $('.main-menu-close');
        this.back = $('.back');
        this.hasSubmenu = $('.menu-item-has-children > a');
        this.links = $('.main-menu a');
        this.isSub = false;
        this.btn = $([...this.$element.find('.burger, button.header-navigation-item'), ...$('[data-menu-trigger]')]);
        this.menusBg = $('.bg');
        
        this.bind();
    }
    
    closeMenu() {
        this.menusBg.removeClass('is-active');
        this.app.dom.$body.removeClass('menu-is-visible');
        this.app.dom.$body.removeClass('submenu-visible');
        this.hasSubmenu.parent().removeClass('submenu-active');
        $('.menu-item').removeClass('submenu-active');
        if (window.innerWidth < 768) {
            $('.sub-menu').slideUp();
        }
        this.isSub = false;
    }

	bind() {
        // function preventDefault(e) {
        //     e = e || window.event;
        //     if (e.preventDefault)
        //         e.preventDefault();
        //     e.returnValue = false;
        //   }
  
        //   function preventDefaultForScrollKeys(e) {
        //       var keys = {37: 1, 38: 1, 39: 1, 40: 1};
        //       if (keys[e.keyCode]) {
        //           preventDefault(e);
        //           return false;
        //       }
        //   }
  
        //   function disableScroll() {
        //     if (window.addEventListener)
        //         window.addEventListener('DOMMouseScroll', preventDefault, false);
        //     window.onwheel = preventDefault;
        //     window.onmousewheel = document.onmousewheel = preventDefault;
        //     window.ontouchmove  = preventDefault;
        //     document.onkeydown  = preventDefaultForScrollKeys;
        //   }
  
        //   function enableScroll() {
        //       if (window.removeEventListener)
        //           window.removeEventListener('DOMMouseScroll', preventDefault, false);
        //       window.onmousewheel = document.onmousewheel = null;
        //       window.onwheel = null;
        //       window.ontouchmove = null;
        //       document.onkeydown = null;
        //   }

        this.on('click', this.btn, () => {
            const activeBg = this.menusBg[Math.floor(Math.random() * this.menusBg.length)];
            $(activeBg).addClass('is-active');

            if (window.innerWidth > 767) {
                this.app.dom.$body.addClass('menu-is-visible');
                // disableScroll();
            } else {
                if (this.app.dom.$body.hasClass('menu-is-visible')) {
                    this.app.dom.$body.removeClass('menu-is-visible');
                    $(activeBg).removeClass('is-active');
                    // enableScroll();
                } else {
                    this.app.dom.$body.addClass('menu-is-visible');
                    // disableScroll();
                }
            }
        })

        this.on('click', this.close, () => {
            this.closeMenu();
            // enableScroll();
        })

        this.on('click', this.links.not(this.hasSubmenu), () => {
            setTimeout(() => {
                this.closeMenu();
                // enableScroll();
            }, 800);
        })

        this.on('click', this.hasSubmenu, (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (window.innerWidth > 767) {
                if (this.isSub == false) {
                    $(e.target).parent().addClass('submenu-active');
                    this.app.dom.$body.addClass('submenu-visible');
                    this.isSub = true;
                } else {
                    if ($(e.currentTarget).parent().hasClass('submenu-active')) {
                        $(e.target).parent().removeClass('submenu-active');
                        this.app.dom.$body.removeClass('submenu-visible');
                        this.isSub = false;
                    } else {
                        setTimeout(() => {
                            $('.submenu-active').removeClass('submenu-active');
                            $(e.currentTarget).parent().addClass('submenu-active');
                            this.app.dom.$body.addClass('submenu-visible');
                            this.isSub = true;
                        }, 100);
                    }
                }
            } else {
                if (this.isSub == false) {
                    $(e.currentTarget).parent().addClass('submenu-active');
                    $(e.currentTarget).parent().find('.sub-menu').slideDown();
                    this.app.dom.$body.addClass('submenu-visible');
                    this.isSub = true;
                } else {
                    if ($(e.currentTarget).parent().hasClass('submenu-active')) {
                        $(e.currentTarget).parent().removeClass('submenu-active');
                        $(e.currentTarget).parent().find('.sub-menu').slideUp();
                        this.app.dom.$body.removeClass('submenu-visible');
                        this.isSub = false;
                    } else {
                        $('.menu-item').removeClass('submenu-active');
                        $('.sub-menu').slideUp();
                        this.app.dom.$body.removeClass('submenu-visible');
                        setTimeout(() => {
                            $(e.currentTarget).parent().addClass('submenu-active');
                            $(e.currentTarget).parent().find('.sub-menu').slideDown();
                            this.app.dom.$body.addClass('submenu-visible');
                            this.isSub = true;
                        }, 50);
                    }
                }
            }
        });

        this.on('touch', this.hasSubmenu, (e) => {
            e.stopPropagation();
            e.preventDefault();
        })

        this.on('click', this.back, () => {
            $('.submenu-active').removeClass('submenu-active');
            this.app.dom.$body.removeClass('submenu-visible');
            this.isSub = false;
        })
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('menu', {
	component: Menu
});
